export const BACKGROUND_IMAGE = "/assets/images/background.jpg";

// SelfieSelector
export const SELFIE_PHOTOS_DESKTOP = 5;
export const SELFIE_PHOTOS_MOBILE = 4;
